/**
 * <StudentStartingBlockPage> — Sam, juste avant d'entrer dans le live (page).
 *
 * Le starting block : l'élève a touché « Entrer dans mon live » et, si sa salle a le drapeau du
 * checkpoint, Sam l'attend pour préparer la séance (le contrôle qui arrive, les devoirs, le
 * chapitre du programme). Avant toute autre question, il fait affirmer la classe si l'élève ne l'a
 * pas fait lui-même depuis la rentrée : « Est-ce que tu es bien en classe de 3ème ? », puis, au
 * besoin, la liste fermée du CP à la Terminale et « Autre », sans saisie libre — rien n'enchaîne
 * sans classe valide. La conversation finit par « C'est parti », qui ouvre le live.
 *
 * Plein écran, comme aujourd'hui, et non une feuille : il n'y a encore rien derrière (l'élève
 * n'est pas dans son live), et une feuille sur la page du test se lirait comme une étape de plus
 * du test. La page ne fait que porter la conversation (`<CheckpointConversation>`) dans la
 * colonne d'un fil ; la croix, au bout de 10 s, entre dans le live sans Sam.
 *
 * Composes DS pieces only — `<PageTemplate>`, `<CheckpointConversation>`.
 */
import React from "react"

import { CheckpointConversation, type CheckpointConversationProps } from "../../organisms/CheckpointConversation"
import { CONVERSATION_MAX_WIDTH } from "../../organisms/ConversationThread"
import { PageTemplate } from "../../templates/PageTemplate"

export type StudentStartingBlockPageProps = Omit<CheckpointConversationProps, "bottomInset">

export function StudentStartingBlockPage(props: StudentStartingBlockPageProps) {
    const { testID, ...conversation } = props

    return (
        <PageTemplate scroll={false} maxContentWidth={CONVERSATION_MAX_WIDTH} padding="0" testID={testID}>
            <CheckpointConversation {...conversation} bottomInset={false} />
        </PageTemplate>
    )
}
